import React from "react";
import { authPaymentTypes } from "../parent/data/auth-payment-types";

export const PaymentTypeContent = (props) => {
  const hasInternalAccountsEqualOrGreaterThanAmountPastDue = () => {
    const amountPastDue = props.loan.AmountPastDue;

    // If there is no amount due, this check is not needed
    if (!amountPastDue || !props.loan.Is90DaysOverdue) return true;

    // If there is an amount due, make sure at least one internal account has a balance equal to or greater than the amount due
    const internalAccounts = props.authPayment.internalAccounts;
    const internalAccountsEqualOrGreaterThanAmountPastDue = internalAccounts.some(
      (account) => account.AvailableBalance >= amountPastDue
    );

    return internalAccountsEqualOrGreaterThanAmountPastDue;
  };

  const advance = (method) => {
    window.scrollTo(0, 0);

    props.setPaymentInfo((state) => {
      return {
        ...state,
        method: method,
        loanId: props.selectedLoanId,
        type: props.paymentType,
        isOpenEnded: props.isOpenEnded,
        isPrincipalOnly: props.isPrincipalOnly,
        hasSelectedPayoff: props.hasSelectedPayoff,
      };
    });
    props.hideModal();
  };

  const circleLoader = (
    <div className="d-flex" style={{ justifyContent: "center" }}>
      <div className="circle-loader m-0" style={{ width: "1em", height: "1em" }} />
      <div className="ml-3">Fetching accounts...</div>
    </div>
  );

  const ltButtonColor = props.authPayment.internalAccountsLoaded ? "#00558c" : "darkgrey";

  const lakeTrustAccount = (
    <button
      className="px-1 w-100 modal-button"
      style={{ color: ltButtonColor, borderColor: ltButtonColor }}
      onClick={() => {
        advance("LakeTrustAccount");
      }}
      disabled={
        !props.authPayment.internalAccountsLoaded || props.authPayment.internalAccounts.length === 0
      }
      data-e2e-id="internalTransfer"
    >
      {props.authPayment.internalAccountsLoaded ? "Pay with Lake Trust Account" : circleLoader}
    </button>
  );

  const bankAccount = (
    <button
      className="px-1 w-100 modal-button"
      onClick={() => advance("BankAccount")}
      data-e2e-id="ach"
    >
      Pay with Bank Account Info
    </button>
  );

  const debitCard = (
    <button
      className="px-1 w-100 modal-button"
      onClick={() => advance("DebitCard")}
      data-e2e-id="debit"
    >
      Pay with Debit Card ($4.95 fee)
    </button>
  );

  const standardOptions = (
    <div>
      {(!props.authPayment.internalAccountsLoaded ||
        props.authPayment.internalAccounts.length > 0) &&
      hasInternalAccountsEqualOrGreaterThanAmountPastDue()
        ? lakeTrustAccount
        : null}
      {props.achIsAllowed ? bankAccount : null}
      {props.paymentType === authPaymentTypes.valid.Standard ? debitCard : null}
    </div>
  );

  return (
    <div>
      <div className="f24 bold">Choose Payment Type</div>
      {standardOptions}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/modal/payment-type-content.component.js